module.exports = __webpack_public_path__ + "static/media/chauffeur.ebde04fa.jpg";